<template>
    <div class="content">
        <div class="hw-content">
            <el-collapse v-model="activeNames">
                <el-collapse-item title="退货单基本信息" name="1">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="退货单编号">
                            <div class="rows">{{ result.Detail.BackBill_SN }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="申请时间">
                            <div class="rows">{{ result.Detail.BackBill_AddTime | formatDates }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="来源订单号">
                            {{ result.Detail.BackBill_OrdersERPSN }}
                        </el-descriptions-item>
                        <el-descriptions-item label="变更合同">
                            <span class="links" @click="goSPCdetail">{{ result.Detail.Orders_SPCOrdersSN }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="来源订单合同纸编码">
                            {{ result.Detail.BackBill_ContractPaperSN }}
                        </el-descriptions-item>
                        <el-descriptions-item label="退货单ERP编号">{{ result.Detail.BackBill_ERPSN }}</el-descriptions-item>
                        <el-descriptions-item label="办事处">{{ result.Detail.Office_Name }}</el-descriptions-item>
                        <el-descriptions-item label="办事处业务员">{{ result.Detail.Orders_OfficeMan }}</el-descriptions-item>
                        <el-descriptions-item label="客户编号">{{ result.Detail.BackBill_CustomerCode }}</el-descriptions-item>
                        <el-descriptions-item label="客户名称">{{ result.Detail.BackBill_CustomerName }}</el-descriptions-item>
                        <el-descriptions-item label="工程名称">{{ result.Detail.Orders_ProjectName }}</el-descriptions-item>
                        <el-descriptions-item label="同步状态">
                            <span :class="judgeColor(result.Detail.BackBillSyncStatusName)">{{ result.Detail.BackBillSyncStatusName }}</span>
                            (RMA：{{ result.Detail.RMAName }})
                        </el-descriptions-item>
                        <el-descriptions-item label="处理状态">{{ result.Detail.BackBillStatusName }}</el-descriptions-item>
                        <el-descriptions-item label="合同审核状态">
                            <span :class="judgeColor(result.Detail.AttachmentAuditName)">{{ result.Detail.AttachmentAuditName }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="合同纸回收状态	">
                            <span :class="judgeColor(result.Detail.RecoverStatusName)">{{ result.Detail.RecoverStatusName }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="电子签章状态">
                            <span :class="judgeColor(Orders_ESignStatus)">{{ Orders_ESignStatus }}</span>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>
                <el-collapse-item title="电子签章" name="2" v-if="orderDetails.Orders_ESignStatus > 0">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="签章状态">
                            <div class="rows">
                                <span :class="judgeColor(Orders_ESignStatus)">{{ Orders_ESignStatus }}</span>
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item label="联系人">
                            <div class="rows">{{ orderDetails.Orders_ESignName }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="联系人手机">
                            <div class="rows">{{ orderDetails.Orders_EsignMobile }}</div>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>

                <el-collapse-item title="退货清单" name="3">
                    <el-table :data="result.Goods" border style="width: 100%" :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                        <el-table-column prop="Goods_Product_Code" label="商品编码" align="center"></el-table-column>
                        <el-table-column prop="Goods_Product_Name" label="商品名称" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="Goods_Product_SourcePrice" label="原始价格" align="center">
                            <template v-slot="scope">
                                <span class="is-status-text">￥ {{ getFloat(scope.row.Goods_Product_SourcePrice,2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Goods_Product_Price" label="申请价格" align="center">
                            <template v-slot="scope">
                                <span class="is-status-text">￥ {{ getFloat(scope.row.Goods_Product_Price,2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Goods_Product_Amount" label="数量" align="center"></el-table-column>
                        <el-table-column prop="Goods_Product_SourcePrice" label="合计" align="center">
                            <template v-slot="scope">
                                <div class="is-status-text">
                                    {{ getFloat(Number((scope.row.Goods_Product_Price * scope.row.Goods_Product_Amount)),2) }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Goods_RMALineNo" label="退货行号" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="SyncStatusName" label="同步状态" align="center">
                            <template v-slot="scope">
                                <span :class="judgeColor(scope.row.SyncStatusName)">{{ scope.row.SyncStatusName }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="margin-top: 10px">
                        合计： ￥
                        <span class="is-status-text">{{ getFloat(returnGoodesPorductPirce,2) }}</span>
                    </div>
                </el-collapse-item>

                <el-collapse-item title="合同附件" name="4">
                    <template slot="title">
                        合同附件
                        <!-- <span v-if="result.IsUpload" style="margin-left: 20px">
                            <el-button type="primary" @click.stop="OrdersBackBillUpload" size="mini">上传</el-button>
                        </span> -->
                        <span v-if="result.IsShowHistory" style="margin-left: 20px">
                            <el-button type="primary" @click.stop="viewHistory" size="mini">查看历史附件</el-button>
                        </span>
                    </template>
                    <el-table :data="result.Attachment" border style="width: 100%" :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                        <el-table-column prop="No" label="序号" align="center" width="80">
                            <template v-slot="scope">
                                {{ scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Attachment_Source" label="附件文件" align="center" width="300" show-overflow-tooltip>
                            <template v-slot="scope">
                                <span class="operation-bar-block" @click="downFile(scope.row.Attachment_Path)">{{ scope.row.Attachment_Source }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Attachment_AuditNote" label="审核备注" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="Attachment_Addtime" label="上传时间" align="center" width="150">
                            <template v-slot="scope">
                                {{ scope.row.Attachment_Addtime | formatDates }}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-collapse-item>
            </el-collapse>
        </div>
        <el-dialog :visible.sync="historyShow" v-if="historyShow" width="1200px" title="历史附件" :top="'15%'" class="custom-dialog">
            <el-table :data="History" border style="width: 100%" :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                <el-table-column prop="No" label="序号" align="center" width="80">
                    <template v-slot="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="Attachment_Source" label="附件文件" align="center" width="300" show-overflow-tooltip>
                    <template v-slot="scope">
                        <span class="operation-bar-block" @click="downFile(scope.row.Attachment_Path)">{{ scope.row.Attachment_Source }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Attachment_AuditNote" label="审核备注" align="center" show-overflow-toolti></el-table-column>
                <el-table-column prop="Attachment_Addtime" label="上传时间" align="center" width="150">
                    <template v-slot="scope">
                        {{ scope.row.Attachment_Addtime | formatDates }}
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
                <el-button type="primary" @click="historyShow = false">关闭</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="uploadShow" width="600px" title="上传文件" :top="'15%'" class="custom-dialog">
            <Hwupload ref="Hwupload" @ontempList="onSuccessUpload" :status="'orderattachment'" />
        </el-dialog>
    </div>
</template>
<script>
import Hwupload from '@/components/Hwupload/indexMany';
export default {
    name: 'returnGoodsDetails',
    components: {
        Hwupload
    },
    props: {},
    data() {
        return {
            details: {},
            activeNames: ['1', '2', '3', '4', '5'],
            orderDetails: { Orders_ESignStatus: 0, Orders_ESignName: '', Orders_EsignMobile: '' }, //合同详情，用来判断电子签章是否显示
            Orders_ESignStatus: '',
            returnGoodesPorductPirce: 0,
            result: {
                Detail: {
                    Office_Name: '',
                    Orders_OfficeMan: '',
                    Orders_SPCOrdersSN: '',
                    BackBillSyncStatusName: '',
                    BackBillStatusName: '',
                    AttachmentAuditName: '',
                    RecoverStatusName: '',
                    RMAName: '--',
                    Orders_ProjectName: '',
                    BackBill_AddTime: '',
                    BackBill_AttachmentAudit: 1,
                    BackBill_AttachmentAudit_Time: '',
                    BackBill_ContractPaperSN: '',
                    BackBill_CustomerCode: '',
                    BackBill_CustomerID: 279,
                    BackBill_CustomerName: '',
                    BackBill_ERPSN: '',
                    BackBill_ID: 9,
                    BackBill_OfficeCode: '',
                    BackBill_OfficeID: 191,
                    BackBill_OfficeManCode: '',
                    BackBill_OfficeManID: 54,
                    BackBill_OrdersERPSN: '',
                    BackBill_RMA: 0,
                    BackBill_RecoverStatus: 0,
                    BackBill_SN: '',
                    BackBill_SPCOrdersID: 342,
                    BackBill_Status: 1,
                    BackBill_SyncStatus: 0,
                    BackBill_SyncTime: '',
                    BackBill_TotalPrice: 90.65
                },

                Goods: [],
                Attachment: [],
                IsUpload: false,
                IsShowHistory: false
            },
            History: [],
            id: 0, // 退货单ID
            uploadShow: false, //上传弹窗
            historyShow: false //历史附件
        };
    },
    mounted() {
        const id = this.$route.query.id;
        if (id) {
            this.id = id;
            this.getOrdersBackBillByID(this.id);
        }
    },
    methods: {
        /*
        获取详情数据
        */
        async getOrdersBackBillByID(id) {
            const res = await this.$newsApi.getOrdersBackBillByID({ id });
            if (res.data.Resultcode == 0) {
                this.result = res.data.data;
                this.returnGoodesPirce();
                try {
                    var result = await this.$newsApi.order.getSPCOrdersByID({
                        ID: this.result.Detail.BackBill_SPCOrdersID
                    });
                    this.orderDetails = result.data.data;
                    this.getOrdersESignStatus(this.orderDetails.Orders_ESignStatus); //获取
                } catch (error) {
                    this.orderDetails = {};
                    this.Orders_ESignStatus = '';
                }

                if (this.result.IsShowHistory) {
                    this.$newsApi.getOrdersBackBillAttachmentsHistoryByOrdersID({ id }).then((r) => {
                        if (r.data.Resultcode == 0) {
                            this.History = r.data.data;
                        }
                    });
                }
            }
        },
        // 查询电子签章状态
        async getOrdersESignStatus(e) {
            const result = await this.$newsApi.order.getOrdersESignStatus({ status: e });
            this.Orders_ESignStatus = result.data.data;
        },
        // 跳转合同详情
        goSPCdetail() {
            this.$router.push({ path: '/contractreturnManagement/details', query: { id: this.result.Detail.BackBill_SPCOrdersID } });
        },
        /*
        计算合计行
        */
        getSummaries(param) {},
        //计算退货商品总价
        returnGoodesPirce() {
            this.returnGoodesPorductPirce = 0;
            this.result.Goods.forEach((item, index) => {
                this.returnGoodesPorductPirce += Number((item.Goods_Product_Price * item.Goods_Product_Amount).toFixed(2));
            });
            this.returnGoodesPorductPirce = this.returnGoodesPorductPirce.toFixed(2);
        },
        /*
        关闭详情
        */
        handleClose() {
            this.$emit('handleClose');
        },
        /*
        打开文件
        */
        downFile(par, flag) {
            if (flag) {
                window.open(par);
                return;
            }
            this.$newsApi.common.getUrlPath().then((res) => {
                if (res.data.Resultcode == 0) {
                    let path = res.data.data;
                    let paths = path + par;
                    window.open(paths);
                }
            });
        },
        // 上传
        async OrdersBackBillUpload() {
            let res = await this.$newsApi.CheckOrdersBackBillAttachmentUpload({ ID: this.id });
            if (res.data.Resultcode != '0') {
                this.$message.error(res.data.Resultinfo);
                return;
            }
            this.uploadShow = true;
        },
        async onSuccessUpload(e) {
            let json = e.join('|');
            let res = await this.$newsApi.Orders_BackBill_Attachment_Edit({
                ID: this.id,
                orders_attachment: json
            });
            if (res.data.Resultcode == '0') {
                this.$message.success('上传成功');
                this.getOrdersBackBillByID(this.id);
                this.uploadShow = false;
                return;
            }
        },
        viewHistory() {
            this.historyShow = true;
        }
    }
};
</script>

<style lang="scss" scoped>
/* .hw-content 的样式 */
.hw-content {
    padding: 0 20px;
}

/* 通用样式 */
.rows {
    width: 389px;
}
.content {
    background: #fff;
    padding: 20px 0;
}
.links {
    color: #409eff;
    cursor: pointer;
}
/deep/.el-table th.el-table__cell.is-leaf,
.el-table td.el-table__cell {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
}
/deep/.el-table--border .el-table__cell {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
}
/deep/.el-table {
    border: 1px solid #ccc;
}
</style>
